export default __webpack_public_path__ + "ade18c699e486b43cf9e1f62dca073ee.png";